<template>
  <div class="form-wrap">
    <el-form ref="baseForm" :class="['demo-ruleForm', { inline: isInline }, ]" :model="formData" :rules="rules" :label-width="labelWidth">
      <el-form-item
        v-for="item in formOptions"
        :key="item.prop"
        :label="item.label"
        :prop="item.prop"
        :style="item.style || {}"
      >
        <!-- 输入框 -->
        <el-input
          v-if="item.type === 'input' || undefined"
          v-model="privacyObj[isPrivacy && item.privacyType ? 'privacyData' : 'formData'][item.prop]"
          :placeholder="item.placeholder || '请输入'"
          @change="(val) => formItemChang(val, item.prop, item.privacyType)"
          @focus="(val) => formItemFocus(val, item.prop, item.privacyType)"
          @blur="(val) => formItemBlur(val, item.prop, item.privacyType)"
          clearable
          :disabled="item.disabled"
        >
        <template slot="append" v-if="item.templateNote">
          {{ item.templateNote }}
        </template>
      </el-input>
        <!-- 文本域 -->
        <el-input
          v-if="item.type === 'textarea'"
          v-model="formData[item.prop]"
          type="textarea"
          :rows="item.rows || 3"
          :placeholder="item.placeholder || '请输入'"
          @change="(val) => formItemChang(val, item.prop)"
          clearable
          :disabled="item.disabled"
        ></el-input>
        <!-- 数字输入框 -->
        <el-input-number
          v-if="item.type === 'input-number'"
          v-model="formData[item.prop]"
          :min="item.min || 0"
          :disabled="item.disabled"
          clearable
          @change="(val) => formItemChang(val, item.prop)"
        >
        </el-input-number>
        <!-- 基本下拉框 -->
        <el-select
          v-if="item.type === 'select'"
          v-model="formData[item.prop]"
          :multiple="item.multiple"
          :placeholder="item.placeholder || '请选择'"
          :disabled="item.disabled"
          @change="(val) => formItemChang(val, item.prop)"
          clearable
          filterable
		      allow-create
        >
          <el-option
            v-for="option in item.options"
            :key="option.value"
            :label="option.label"
            :value="option.value">
          </el-option>
        </el-select>
        <!-- 基本单选-->
        <el-radio-group
          v-if="item.type === 'radio'"
          v-model="formData[item.prop]"
          :disabled="item.disabled"
          @change="(val) => formItemChang(val, item.prop)"
        >
          <el-radio
            v-for="radio in item.options"
            :key="radio.label"
            :label="radio.value"
          >
            {{radio.label}}
          </el-radio>
        </el-radio-group>
        <!-- 远程数据筛选 -->
        <el-select
          v-if="item.type === 'select-search'"
          v-model="formData[item.prop]"
          :placeholder="item.placeholder || '请输入'"
          @change="(val) => formItemChang(val, item.prop)"
          :remote-method="(query) => selectRemoteMethod(query, item)"
          :loading="selectLoading"
          :disabled="item.disabled"
          clearable
          filterable
          remote
        >
          <el-option
            v-for="option in item.options"
            :key="option.value"
            :label="option.label"
            :value="option.value">
          </el-option>
        </el-select>
        <!-- 多选组 -->
        <el-checkbox-group
          v-if="item.type === 'checkbox'"
          v-model="formData[item.prop]"
          :disabled="item.disabled"
          @change="(val) => formItemChang(val, item.prop)"
        >
          <el-checkbox
            v-for="check in item.options"
            :key="check.label"
            :label="check.value"
          >
            {{check.label}}
          </el-checkbox>
        </el-checkbox-group>
        <!-- 日期 -->
        <el-date-picker
          v-if="item.type === 'date'"
          v-model="formData[item.prop]"
          :placeholder="item.placeholder || 请选择日期"
          :value-format="item.format || 'yyyy-MM-dd'"
          :disabled="item.disabled"
          @change="(val) => formItemChang(val, item.prop)"
        >
        </el-date-picker>
        <!-- 日期时间 -->
        <el-date-picker
          v-if="item.type === 'date-time'"
          type="datetime"
          v-model="formData[item.prop]"
          :placeholder="item.placeholder || '请选择日期'"
          :value-format="item.format || 'yyyy-MM-dd HH:mm:ss'"
          :disabled="item.disabled"
          @change="(val) => formItemChang(val, item.prop)"
        >
        </el-date-picker>
        <!-- 时间区间 -->
        <el-time-picker
          v-if="item.type === 'range-picker'"
          is-range
          v-model="formData[item.prop]"
          range-separator="-"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          placeholder="选择时间范围"
          :disabled="item.disabled"
          @change="(val) => formItemChang(val, item.prop)"
        >
        </el-time-picker>
        <!-- 日期区间 -->
        <el-date-picker
          v-if="item.type === 'range-date'"
          v-model="formData[item.prop]"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          placeholder="选择日期范围"
          value-format="yyyy-MM-dd"
          :disabled="item.disabled"
          @change="(val) => formItemChang(val, item.prop)"
        >
        </el-date-picker>
        <!-- 日期时间区间 -->
        <el-date-picker
          v-if="item.type === 'range-date-time'"
          v-model="formData[item.prop]"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd hh:mm:ss"
          :disabled="item.disabled"
        >
        </el-date-picker>
        <!-- 级联 -->
        <el-cascader
          v-if="item.type === 'cascader'"
          v-model="formData[item.prop]"
          :options="item.options"
          :props="item.propConfig || {}"
          @change="(val) => formItemChang(val, item.prop)"
          :placeholder="item.placeholder || '请选择'"
          :disabled="item.disabled"
        >
        </el-cascader>
        <!-- 富文本编辑器 -->
        <!-- <Editor
          v-if="item.type === 'editor'"
          v-model="formData[item.prop]"
          :height="item.editorHeight || 600"
          :minHeight="item.editorMinHeight || 400"
        /> -->
		<!-- <Tinymce 
		 v-if="item.type === 'editor'"
		 v-model="formData[item.prop]"
		 :height="item.editorHeight || 600"
		 :minHeight="item.editorMinHeight || 400"
		 ></Tinymce> -->
		  <kindeditor
		     v-if="item.type === 'editor'"
			 :height="item.editorHeight || 600"
			 :width="item.editorWidth || 400"
			 :loadStyleMode="false"
			 :content.sync="formData[item.prop]"
			 :id="item.prop"
			 pluginsPath="/static/kindeditor/plugins/"
		   />
        <!-- 图片上传 -->
        <el-upload
          v-if="item.type === 'upload'"
          drag
          action="#"
          multiple
          :file-list="formData[item.prop]"
          :limit="item.limit || 1"
          :on-change="(file, fileList) => formItemChang(file, item.prop)"
          :auto-upload="false"
          :disabled="item.disabled"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">拖拽上传/<em>点击上传</em></div>
        </el-upload>
        <slot v-if="item.slotName" :name="item.slotName"></slot>
      </el-form-item>
      <slot></slot>
    </el-form>
  </div>
</template>

<script>

export default {
  name: 'BaseForm',
  props: {
    // 双向绑定数据源头
    formData: {
      type: Object,
      default: () => ({})
    },
    // 校验
    rules: {
      type: Object,
      default: () => ({})
    },
    // 表单配置
    formOptions: {
      type: Array,
      default: () => ({})
    },
    // item-label宽度全局设置
    labelWidth: {
      type: String,
      default: '100px'
    },
    // 是否行内展示
    isInline: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'formData',
    event: 'change'
  },
  data() {
    return {
      levelList: null,
      privacyObj: {
        privacyData: null, // 原始数据处理后的敏感信息
        formData: null
      },
      isPrivacy: this.$store.state.user.group_id == 17,
      focusValue: {},
    }
  },
  watch: {
    formData: {
      handler(newVal) {
        // console.log('变化啦。。。。。。。',newVal);
        this.privacyObj.formData = newVal
      },
      deep: true, // 监控对象内部的变化
    },
  },
  created() {
    this.privacyObj.privacyData = JSON.parse(JSON.stringify(this.formData))  // 深拷贝
    this.privacyObj.formData = JSON.parse(JSON.stringify(this.formData))  // 深拷贝
    // 处理敏感信息，formOptions中配置privacyType=true代表敏感信息
    this.formOptions.forEach(item => {
      if(item.privacyType) {
        this.privacyObj.privacyData[item.prop] = this.privacyFun(this.privacyObj.privacyData[item.prop])
      }
    })
  },
  methods: {
    // change事件
    formItemChang() {
      // arguments  val  prop
      this.$emit('formChange', ...arguments)
    },
    formItemFocus(e,prop,type) {
      if(this.isPrivacy && type) {
        this.focusValue[prop] = this.privacyObj[this.isPrivacy && type ? 'privacyData' : 'formData'][prop]
        this.privacyObj[this.isPrivacy && type ? 'privacyData' : 'formData'][prop] = ''
      }
    },
    formItemBlur(e,prop,type) {
      // 值为空 表示未修改
      if(this.privacyObj[this.isPrivacy && type ? 'privacyData' : 'formData'][prop] == '') {
        this.privacyObj[this.isPrivacy && type ? 'privacyData' : 'formData'][prop] = this.focusValue[prop]
      } else {
        this.formData[prop] = e.target.value
      }
    },
    // 提交方法
    onSubmit(cb) {
      this.$refs.baseForm.validate((valid) => {
          if (valid) {
            cb(true)
          } else {
            cb(false)
            return false;
          }
        });
    },
    // 搜索框远程搜索触发函数
    selectRemoteMethod(val, optionItem) {
      this.selectLoading = true
      optionItem.remoteMethod ?? optionItem.remoteMethod(val, () => {
        this.selectLoading = false
      })
    },

    // 重置表单
    resetFields() {
      this.$refs.baseForm.resetFields();
    },

    // 移除校验
    clearValidate(prop) {
      this.$refs.baseForm.clearValidate(prop);
    },
    
    // 隐私处理
    privacyFun(str) {
      if(str){

        const firstEnglishCharIndex = str.search(/[a-zA-Z0-9]/);
        if(firstEnglishCharIndex === 0) {
          // str = str.replace(/[\u4e00-\u9fff]/g, '');  // 过滤中文字符
          // const startLength = Math.floor((str.length - 4) / 2);
          // const endLength = str.length - startLength - 4;
          // const regex = new RegExp(`^(.{${startLength}})(.{4})(.{${endLength}})$`);
          // return str.replace(regex, `$1****$3`);
          return str.slice(0, 4) + '*'.repeat(str.length - 4);
        } else {
          return str.slice(0, firstEnglishCharIndex) + '*'.repeat(str.length - firstEnglishCharIndex);
        }

      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form-wrap {
  :deep(.el-upload-dragger) {
    width: 150px;
    height: 150px;
  }
  :deep(.el-form)  {
    display: flex;
    flex-wrap: wrap;
    .el-form-item {
      display: flex;
      width: 100%;
    }
    .el-form-item__label {
      flex-shrink: 0;
    }
    .el-form-item__content {
      flex: 1;
      margin-left: 0px !important;
    }
    .el-input {
      width: 100%;
    }
    .el-select {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
    .el-cascader {
      width: 100%;
    }
  }
  :deep(.inline) {
    display: flex;
    .el-form-item {
        display: flex;
        flex-shrink: 0;
        width: 50%;
    }
    .el-form-item__label {
      flex-shrink: 0;
    }
    .el-input {
      width: 100%;
    }
    .el-select {
      width: 100%;
    }
    .el-date-editor {
      width: 100%;
    }
    .el-cascader {
      width: 100%;
    }
  }
}
</style>
